import { render, staticRenderFns } from "./Physio.vue?vue&type=template&id=3ad040d0&scoped=true"
import script from "./Physio.vue?vue&type=script&lang=js"
export * from "./Physio.vue?vue&type=script&lang=js"
import style0 from "./Physio.vue?vue&type=style&index=0&id=3ad040d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad040d0",
  null
  
)

export default component.exports